import { render, staticRenderFns } from "./EModalExportarAula.vue?vue&type=template&id=54ad70c6"
import script from "./EModalExportarAula.vue?vue&type=script&lang=js"
export * from "./EModalExportarAula.vue?vue&type=script&lang=js"
import style0 from "./EModalExportarAula.vue?vue&type=style&index=0&id=54ad70c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports